import axios from "axios";

const API_URL = "https://support.mcdonalds.mu/api"; //live

// const API_URL = "https://ticketsystem.encantotech.in/api";

export async function apiRequest({
  method = "GET",
  url,
  data = null,
  params = null,
  responseType = "json",
  timeout = 15000,
}) {
  try {
    const token =
      typeof window !== "undefined" ? localStorage.getItem("token") : null;

    const isFormData = data instanceof FormData;

    const config = {
      method,
      url: `${API_URL}${url}`,
      timeout,
      headers: {
        Accept: "application/json",
        ...(isFormData ? {} : { "Content-Type": "application/json" }),
        ...(token && { Authorization: `Bearer ${token}` }),
      },
      ...(data && { data }),
      ...(params && { params }),
    };

    const response = await axios(config);
    if (responseType === "blob") return response;
    return response.data;
  } catch (error) {
    if (error.code === "ECONNABORTED" || error.code === "ETIMEDOUT") {
      throw {
        status: null,
        message: "Request timed out. Please try again.",
      };
    }

    if (!error.response) {
      throw {
        status: null,
        message: "Network error. Please check your internet connection.",
      };
    }

    const { status, data } = error.response;

    if (status === 401 || status === 403) {
      if (typeof window !== "undefined") {
        localStorage.removeItem("token");
        // window.location.replace("/");
      }

      throw {
        status,
        message: data?.message || "Session expired. Please login again.",
      };
    }

    if (status === 400 || status === 422) {
      throw {
        status,
        message: data?.message || "Validation failed",
        errors: data?.errors || null,
      };
    }

    if (status === 404) {
      throw {
        status,
        message: data?.message || "Resource not found",
      };
    }

    if (status >= 500) {
      throw {
        status,
        message: "Server error. Please try again later.",
      };
    }

    throw {
      status,
      message: data?.message || "Something went wrong",
    };
  }
}
